export enum EDateInputAdditionalClass {
    cellStyle = 'cell-style'
}
